var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.9,3.1L8,9.2l6.1-6.1L16,4.9l-8,8l-8-8L1.9,3.1z","fill":"currentColor"}));
}

ChevronDown.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
